import {Component} from '@angular/core';
import {AccessRequest} from '../models/access-request';
import {Observable} from 'rxjs/Observable';
import * as fromRoot from '../reducers';
import * as actions from '../actions/register';
import {Store} from '@ngrx/store';

@Component({
  selector: 'app-register',
  template: `<div class="row justify-content-center" style="padding-top:20px;">
    <div class="col-md-4">
      <div class="card">
        <div class="card-header">
          <h6>Request System Access</h6>
        </div>
        <div class="card-body">
          <register-form (submitRegistration)="register($event)" 
                         [registered]="registered$ | async"
                         [working]="working$ | async"></register-form>
          <registered-message [registered]="registered$ | async"></registered-message>
        </div>
      </div>
    </div>
  </div>
  `
})
export class RegisterPageComponent {

  public registered$: Observable<boolean>;
  public working$: Observable<boolean>;

  constructor(private store: Store<fromRoot.State>) {
    this.registered$ = this.store.select(fromRoot.getRequestSubmitted);
    this.working$ = this.store.select(fromRoot.getRequestWorking);
    this.store.dispatch(new actions.ClearAccessRequestScreenAction());
  }

  public register(req: AccessRequest) {
    this.store.dispatch(new actions.RequestAccessAction(req));
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/containers/register.ts